var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('iframe',{attrs:{"src":"https://senhadigital.com.br/htmlpages/documentos-necessarios/index.html","width":"100%","height":"1361px"}})])
}]

export { render, staticRenderFns }